import React from 'react';
import { Text, useThemeName } from '@tamagui/core';
import { YStack, XStack } from '@tamagui/stacks';
import { Phone } from 'lucide-react-native';

export type ContactPhoneItemProps = {
  phone: string;
  statusLabel?: string;
  statusBackgroundColor?: string;
  statusTextColor?: string;
};

const ContactPhoneItem: React.FC<ContactPhoneItemProps> = ({
  phone,
  statusLabel,
  statusBackgroundColor,
  statusTextColor,
}) => {
  const themeName = useThemeName();
  const iconColor = themeName === 'dark' ? '#d4d4d8' : '#71717a';
  const titleColor = themeName === 'dark' ? '#ffffff' : '#18181b';
  const subtitleColor = themeName === 'dark' ? '#a1a1aa' : '#71717a';
  const softBorder = themeName === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)';

  return (
    <YStack
      backgroundColor="$gray2"
      borderRadius="$4"
      padding="$3"
      borderWidth={1}
      borderColor={softBorder}
    >
      <XStack alignItems="center" paddingVertical={8}>
        <YStack
          width={40}
          height={40}
          borderRadius="$2"
          backgroundColor="$gray4"
          borderWidth={1}
          borderColor={softBorder}
          alignItems="center"
          justifyContent="center"
        >
          <Phone size={20} color={iconColor} />
        </YStack>

        <YStack flex={1} marginLeft={12}>
          <Text fontSize="$4" fontWeight="500" color={titleColor}>
            Telefon
          </Text>
          <Text fontSize="$3" color={subtitleColor} marginTop="$1">
            {phone}
          </Text>
        </YStack>

        {statusLabel && (
          <YStack
            backgroundColor={statusBackgroundColor}
            paddingHorizontal="$3"
            paddingVertical="$1"
            borderRadius="$3"
          >
            <Text fontSize="$2" fontWeight="500" color={statusTextColor}>
              {statusLabel}
            </Text>
          </YStack>
        )}
      </XStack>
    </YStack>
  );
};

export default ContactPhoneItem;
